import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useShoppingCart } from '../../../context/CartContext.tsx/ShoppingCartContext';
import { addPaymentInfoEvent, pushCartItem } from '../../../utils/GoogleAnalytics';



interface cashOnDeliveryProps {
    cart_id: number | any;
    cod: number | any;
    onClick?: any;
    shipping_charge?: number | any
    total?: number | any 
    gold_free_item?:any
    gold_variant?:any
    is_gold_member?: boolean | any
    is_lk_gold_member?:boolean | any    
}

export const CashOnDelivery = ({ cart_id, cod , shipping_charge, total, gold_free_item, gold_variant, is_gold_member, is_lk_gold_member }: cashOnDeliveryProps) => {
    const { getCartData, applyCod, removeCod } = useShoppingCart();
    const [isChecked, setIsChecked] = useState(cod === 1 ? true : false);


    const data = getCartData;
  const tempCartItems:any = data?.data[0]?.temp_cart_items;

  let cart_item_array:any = [];

  const cartItemsEvent = pushCartItem(tempCartItems, cart_item_array);


    const applyCodPayload = {
        "cart_id": cart_id,
        "cod": true
    }

    const removeCodPayload = {
        "cart_id": cart_id
    }

    function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        if (event.target.checked) {
            applyCod(applyCodPayload)
            setIsChecked(true)
            addPaymentInfoEvent('cod',cartItemsEvent)

        } else {
            removeCod(removeCodPayload)
            setIsChecked(false)
        }

    }


    // console.log(total);

    return (
        <div  className={`codWrapper ${parseInt(total) === 0 ? 'opacity-60' : '' }`} >
        {/* <div  className="codWrapper"> */}

            {/* <div className="codContent"> */}

            <div className={`codContent ${parseInt(total) > 299 ? 'codContentPadding' : ''}`}>


                
                {cod === 1 ?
                    <div className='codCheck'>
                        <p className="codTitle">Cash On Delivery Added</p>
                        { parseInt(total) > 299  || is_gold_member || is_lk_gold_member || gold_variant ?
                            <p className='codSubTitle'>You availed Free Delivery on this order.</p>
                            :
                            <p className='codSubTitle'>A Rs.{shipping_charge} charge applies to cash on delivery orders.</p>
                        }
                    </div>

                    :
                    <div className='codCheck'>
                        <p className="codTitle">Cash On Delivery</p>
                        { parseInt(total) > 299 || is_gold_member || is_lk_gold_member || gold_variant ? 
                        <p className='codSubTitle'>You availed Free Delivery on this order.</p>
                        :
                        <p className='codSubTitle'>Delivery Charge of Rs.49 will be applicable below Rs. 299</p>
                    }
                    </div>
                }


                <div className="checkboxWrapper">
                    <label className="payOnDelivery-checkbox">
                        <input
                            type="checkbox" className="add-cod"
                            name="payOnDelivery"
                            onChange={handleChange}
                            value={isChecked.toString()}
                            checked={isChecked}
                            disabled={parseInt(total) === 0}
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
                
            </div>
        </div>
    )
}


